import { FC } from 'react'
import { Container } from './styled'

const ContentBlock: FC = ({ children }) => {
   return <Container>{children}</Container>
}

export default ContentBlock
